import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=5c37ccfb&scoped=true"
import script from "./AppCard.vue?vue&type=script&lang=js"
export * from "./AppCard.vue?vue&type=script&lang=js"
import style0 from "./AppCard.vue?vue&type=style&index=0&id=5c37ccfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37ccfb",
  null
  
)

export default component.exports